import { Application } from '@hotwired/stimulus';
import { registerControllers } from 'stimulus-vite-helpers';
import { registerShadcnControllers } from 'shadcn-rails-stimulus';
import UiProgressComponentController from '../../components/ui/progress_component_controller.js';
import Clipboard from 'stimulus-clipboard';
import ShadcnNavigationMenuController from './shadcn/navigation_menu_controller.js';

const application = Application.start();

application.register('clipboard', Clipboard);
application.register('ui--progress-component', UiProgressComponentController);
registerShadcnControllers(application);
application.register('shadcn--navigation-menu', ShadcnNavigationMenuController);

const LAZY_CONTROLLERS = {
  'apps-script-commenter': () => import('./apps_script_commenter_controller.jsx'),
  'coding-challenge': () => import('./coding_challenge_controller.jsx'),
  'snippet': () => import('./snippet_controller.jsx'),
  'characters': () => import('./characters_controller.js'),
};

const LAZY_CONTROLLER_FILES = new Set([
  './apps_script_commenter_controller.jsx',
  './coding_challenge_controller.jsx',
  './snippet_controller.jsx',
  './characters_controller.js',
]);

function registerLazyControllers() {
  for (const [identifier, loader] of Object.entries(LAZY_CONTROLLERS)) {
    if (application.router.modulesByIdentifier?.has(identifier)) continue;
    if (!document.querySelector(`[data-controller~="${identifier}"]`)) continue;

    loader()
      .then((module) => {
        // vite:preloadError (see entrypoints/application.js) can swallow a failed import and
        // resolve with undefined while the page reloads.
        if (!module?.default) return;
        if (application.router.modulesByIdentifier?.has(identifier)) return;
        application.register(identifier, module.default);
      })
      .catch((error) => {
        console.error(`Error loading ${identifier} controller:`, error);
      });
  }
}

const controllerModules = import.meta.glob('./**/*_controller.{js,ts}', { eager: true });
const eagerControllerModules = Object.fromEntries(
  Object.entries(controllerModules).filter(
    ([path]) => !LAZY_CONTROLLER_FILES.has(path) && !path.includes('/shadcn/')
  )
);

try {
  registerControllers(application, eagerControllerModules);
} catch (error) {
  console.error('Error registering controllers:', error);
}

document.addEventListener('turbo:load', registerLazyControllers);
registerLazyControllers();

application.warnings = true;
application.debug = import.meta.env.DEV;

window.Stimulus = application;
